/**
 * Maximum file size for image file uploads. This is equal to
 * `ImageUploadMaxFileSize` in `PageController.php`.
 */
export const MAX_IMAGE_SIZE_MB = 20;

/**
 * Maximum file size for file uploads. This is equal to `UploadMaxFileSize`
 * in `PageController.php`.
 */
export const MAX_UPLOAD_SIZE_MB = 180;
